export default __webpack_public_path__ + "static/media/play-dark.b8014374.svg";